import { ColumnFiltersState } from "@tanstack/react-table";
import { createContext, useContext } from "react";

export interface LegislationTableFilterContextValue {
  hasInitializedDefaults: boolean;
  initializeDefaults: (
    columnFilters: ColumnFiltersState,
    defaultsPlan: {
      sourceKey: string;
      childFilters: { id: string; value: unknown }[];
    } | null
  ) => ColumnFiltersState;
  markDefaultsInitialized: () => void;
}

export const LegislationTableFilterContext = createContext<
  LegislationTableFilterContextValue | undefined
>(undefined);

const useLegislationTableFilterContext = () => {
  const context = useContext(LegislationTableFilterContext);
  if (!context) {
    throw new Error(
      "useLegislationTableFilterContext must be used within LegislationFilterConfigProvider"
    );
  }
  return context;
};

export const useLegislationTableFilterState = () => {
  return useLegislationTableFilterContext();
};
